import { render, staticRenderFns } from "./AttributesList.vue?vue&type=template&id=cdbc9924&"
import script from "./AttributesList.vue?vue&type=script&lang=ts&"
export * from "./AttributesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports